<template>
  <v-container>
    <v-card-title class="text-overline">
      <div class="d-flex">
        <div class="text-green-darken-3 text-h3 font-weight-bold">
          {{ progressPercentage }}%
        </div>
        <v-spacer />
        <div
          class="text-h3 text-medium-emphasis font-weight-regular"
          v-if="balance >= 0"
        >
          {{ formatRawCost(balance) }} remaining
        </div>
      </div>
    </v-card-title>
    <br />
    <v-card-text>
      <div
        v-if="balance >= 0 && props.donationAmountCents > 0"
        :style="`left: calc(${yourGiftPercent}% - 32px)`"
        class="position-absolute mt-n8 text-caption text-green-darken-3"
      >
        Your Gift
      </div>
      <v-progress-linear
        color="green-darken-3"
        height="22"
        :model-value="progressPercentage"
        :buffer-value="yourGiftPercent"
        rounded="lg"
      >
      </v-progress-linear>

      <div class="d-flex justify-space-between py-3">
        <span class="text-green-darken-3 font-weight-medium">
          {{ formatRawCost(progress) }} contributed
        </span>

        <span class="text-medium-emphasis">
          {{ formatRawCost(target) }} goal
        </span>
      </div>
    </v-card-text>
  </v-container>
</template>
<script lang="ts" setup>
import type { DonationInitiative } from "@/composables/donations/useDonationNew";
import { useUtility } from "@/composables/useUtility";

const { formatRawCost } = useUtility();

const props = defineProps<{
  donationInitiative: DonationInitiative;
  donationAmountCents: number;
}>();
const target = computed(() => props.donationInitiative.contributionsGoal || 0);
function calcPercent(amount: number) {
  return target.value > 0 ? Math.round((amount / target.value) * 100) : 0;
}
const progress = computed(
  () => props.donationInitiative.contributionsCurrent || 0,
);
const yourGiftPercent = computed(() =>
  calcPercent(progress.value + props.donationAmountCents),
);
const balance = computed(() => target.value - progress.value);
const progressPercentage = computed(() => calcPercent(progress.value));
</script>
